import { render } from "./VideoCoursewareCard.vue?vue&type=template&id=73f1278e&scoped=true"
import script from "./VideoCoursewareCard.vue?vue&type=script&lang=ts"
export * from "./VideoCoursewareCard.vue?vue&type=script&lang=ts"

import "./VideoCoursewareCard.vue?vue&type=style&index=0&id=73f1278e&scoped=true&lang=css"
import "./VideoCoursewareCard.vue?vue&type=style&index=1&id=73f1278e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-73f1278e"

export default script